import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { ArrowLeft, Construction } from 'lucide-react';
import { useAuthStore } from '../stores/authStore';
import { navForRole } from '../shell/roleNav';

// Visually distinct from the centered empty-state (used for "no data") and the
// "Not authorized" state — a dashed "roadmap" card with a badge — so users
// can tell "not built yet" apart from "no data" / "no permission" (MYSKUX-056),
// and it offers a way back (MYSKUX-082).
export function ComingSoon({ icon, title, description }: { icon?: ReactNode; title: string; description: string }) {
  const role = useAuthStore((s) => s.session?.activeRole);
  const home = (role && navForRole(role)[0]?.to) || '/';
  return (
    <div className="coming-soon">
      <div className="coming-soon-badge">
        <Construction size={14} aria-hidden="true" />
        Coming soon
      </div>
      <div className="coming-soon-icon" aria-hidden="true">
        {icon ?? <Construction size={32} />}
      </div>
      <h3>{title}</h3>
      <p>{description}</p>
      <Link to={home} className="btn btn-secondary">
        <ArrowLeft size={16} aria-hidden="true" />
        Back to dashboard
      </Link>
    </div>
  );
}
